module.exports = __webpack_public_path__ + "img/student_31.9080b428.png";